import { Input } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import { useCopyToClipboard } from '../../hooks/useCopyToClipboard';

const SUPPORT_EMAIL = 'support@taskonio.com';

type Props = {
  className?: string;
  size?: 'middle' | 'large';
};

// Read-only support email that copies itself on click, Enter or Space.
export const SupportEmailField = ({ className, size }: Props) => {
  const { copy } = useCopyToClipboard();
  const copyEmail = () => void copy(SUPPORT_EMAIL, 'Email copied');

  return (
    // The whole field is the copy target. role="button" with hand-wired Enter/Space
    // because raw <button> is banned and an input cannot live inside one.
    <div
      role="button"
      tabIndex={0}
      aria-label="Copy support email"
      onClick={copyEmail}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          copyEmail();
        }
      }}
      className={`cursor-pointer ${className ?? ''}`}
    >
      <Input
        readOnly
        tabIndex={-1}
        size={size}
        value={SUPPORT_EMAIL}
        className="pointer-events-none !text-brand-grey-dark"
        suffix={<CopyOutlined className="text-neutral-800" />}
      />
    </div>
  );
};
